import services from 'services';
import {prop} from 'ramda';
import {describeThrow, describeError} from 'utils/errors';
import * as normalize from 'utils/normalize';
import {getResponseData} from 'utils/app';

let httpJson = null;
services.waitFor('api').then(x => (httpJson = x.httpJson));
let intl = null;
services.waitFor('intl').then(x => (intl = x));

export const updateVisitTarget = target =>
	httpJson('put', `/targets/${target.id}`, {}, {body: target})
		.catch(describeThrow(intl.formatMessage({id: 'Failed to save goal'})))
		.then(prop('data'));

export const postVisitTarget = target =>
	httpJson('post', '/targets', {}, {body: target})
		.catch(describeThrow(intl.formatMessage({id: 'Failed to save goal'})))
		.then(prop('data'));

export const getActiveCallPool = () =>
	httpJson('get', '/callPools/active', {project: true})
		.catch(e => {
			const noPools = !!e.response && e.response.status === 404;
			e.causedByNoPoolsAvailable = noPools;
			const errMsgKey = noPools
				? 'No callable buildings'
				: 'Failed to load callable buildings';
			throw describeError(intl.formatMessage({id: errMsgKey}), e);
		})
		.then(getResponseData(normalize.callPool));

export const getNextBuilding = callPoolId =>
	httpJson('get', '/callReservations/nextBuilding', {callPoolId})
		.catch(e => {
			const noBuildings = !!e.response && e.response.status === 404;
			e.causedByNoBuildingsAvailable = noBuildings;
			const errMsgKey = noBuildings
				? 'No more callable buildings'
				: 'Failed to load next callable building';
			throw describeError(intl.formatMessage({id: errMsgKey}), e);
		})
		.then(getResponseData(normalize.building));
